
/**
 * TODO CS - refactor these to one big object:
 * ContactField.createdAt: {
 *   Name: 'Created',
 *   Field: 'created_at',
 * }
 */

import getSpecialSortColumns from '@/Core/utilities/special-sort-columns';

export const ADDRESSES_NAME = 'Address';
export const ADDRESSES_FIELD = 'addresses';

export const ASSIGNED_USER_ID_NAME = 'Assigned User';
export const ASSIGNED_USER_ID_FIELD = 'assigned_user_id';

export const OWNER_USER_ID_NAME = 'Contact Owner';
export const OWNER_USER_ID_FIELD = 'owner_user_id';

export const TAGS_NAME = 'Tags';
export const TAGS_FIELD = 'tag_names';

export const HOTNESS_NAME = 'Hotness';
export const HOTNESS_FIELD = 'hotness';
export const HOTNESS_ID_FIELD = 'hotness_id';

export const EMAIL_PRIMARY_NAME = 'Email';
export const EMAIL_PRIMARY_FIELD = 'email_primary';
export const EMAIL_SECONDARY_NAME = 'Email (Alt)';
export const EMAIL_SECONDARY_FIELD = 'email_secondary';

export const SPOUSE_EMAIL_NAME = 'Spouse Email';
export const SPOUSE_EMAIL_FIELD = 'spouse_email';
export const SPOUSE_PHONE_NAME = 'Spouse Phone';
export const SPOUSE_PHONE_FIELD = 'spouse_phone';

export const PHONE_MOBILE_NAME = 'Phone (Mobile)';
export const PHONE_MOBILE_FIELD = 'phone_mobile';
export const FAX_NAME = 'Fax Number';
export const FAX_FIELD = 'phone_fax';
export const PHONE_HOME_NAME = 'Phone (Home)';
export const PHONE_HOME_FIELD = 'phone_home';
export const PHONE_OFFICE_NAME = 'Phone (Office)';
export const PHONE_OFFICE_FIELD = 'phone_office';

export const CREATED_AT_NAME = 'Created';
export const CREATED_AT_FIELD = 'created_at';
export const LAST_EMAIL_TEXT_SENT_AT_NAME = 'Last Email/Text Sent';
export const LAST_EMAIL_TEXT_SENT_AT_FIELD = 'last_email_text_sent_at';
export const LAST_ACTIVITY_AT_NAME = 'Last Activity';
export const LAST_ACTIVITY_AT_FIELD = 'last_activity_at';
export const LAST_COMMENT_AT_NAME = 'Last Comment';
export const LAST_COMMENT_AT_FIELD = 'last_comment_at';
export const LAST_PHONE_ACTIVITY_AT_NAME = 'Last Phone Activity';
export const LAST_PHONE_ACTIVITY_AT_FIELD = 'last_phone_activity_at';
export const LAST_SITE_VISIT_AT_NAME = 'Last Site Visit';
export const LAST_SITE_VISIT_AT_FIELD = 'last_site_visit_at';
export const LAST_USER_LOGIN_AT_NAME = 'Last Login';
export const LAST_USER_LOGIN_AT_FIELD = 'last_user_login_at';
export const LAST_SEARCH_PERFORMED_AT_NAME = 'Last Search Peformed';
export const LAST_SEARCH_PERFORMED_AT_FIELD = 'last_search_performed_at';
export const LAST_SAVED_SEARCH_ADDED_AT_NAME = 'Last Saved Search';
export const LAST_SAVED_SEARCH_ADDED_AT_FIELD = 'last_saved_search_added_at';
export const LAST_SAVED_SEARCH_REMOVED_AT_NAME = 'Last Saved Search Removed';
export const LAST_SAVED_SEARCH_REMOVED_AT_FIELD = 'last_saved_search_removed_at';
export const LAST_PROPERTY_VIEWED_AT_NAME = 'Last Property Viewed';
export const LAST_PROPERTY_VIEWED_AT_FIELD = 'last_property_viewed_at';
export const LAST_FAVORITE_PROPERTY_ADDED_AT_NAME = 'Last Favorited Property';
export const LAST_FAVORITE_PROPERTY_ADDED_AT_FIELD = 'last_favorite_property_added_at';
export const LAST_FAVORITE_PROPERTY_REMOVED_AT_NAME = 'Last Favorited Property Removed';
export const LAST_FAVORITE_PROPERTY_REMOVED_AT_FIELD = 'last_favorite_property_removed_at';
export const NEXT_AP_TASK_RECURRING_AT_NAME = 'Next Autopilot Task';
export const NEXT_AP_TASK_RECURRING_AT_FIELD = 'next_ap_task_recurring_at';
export const NEXT_TASK_AT_NAME = 'Next Task';
export const NEXT_TASK_AT_FIELD = 'next_task_at';
export const CAMPAIGN_ACTION_NAME = 'Next Campaign Action';
export const CAMPAIGN_ACTION_FIELD = 'next_ap_task_regular_at';

export const TOTAL_ACTIVITIES_NAME = '# Activities';
export const TOTAL_ACTIVITIES_FIELD = 'total_activities';
// export const TOTAL_AP_TASKS_RECURRING_NAME = ;
export const TOTAL_AP_TASKS_RECURRING_FIELD = 'total_ap_tasks_recurring';
export const TOTAL_AP_TASKS_REGULAR_NAME = '# AutoPilot Tasks';
export const TOTAL_AP_TASKS_REGULAR_FIELD = 'total_ap_tasks_regular';
export const TOTAL_CAMPAIGNS_TASKS_NAME = '# Campaign Action Tasks';
export const TOTAL_CAMPAIGNS_TASKS_FIELD = 'total_campaign_action_tasks';
export const TOTAL_COMMENTS_NAME = '# Comments';
export const TOTAL_COMMENTS_FIELD = 'total_comments';
// export const TOTAL_CONTACT_ACTIONS_NAME =;
export const TOTAL_CONTACT_ACTIONS_FIELD = 'total_contact_actions';
export const TOTAL_EMAILS_TEXTS_NAME = '# Sent Emails/Texts';
export const TOTAL_EMAILS_TEXTS_FIELD = 'total_emails_texts';
// export const TOTAL_OTHER_CONTACTS_NAME =;
export const TOTAL_OTHER_CONTACTS_FIELD = 'total_other_contactsnull';
export const TOTAL_PHONE_ACTIVITY_NAME = '# Phone Activity';
export const TOTAL_PHONE_ACTIVITY_FIELD = 'total_phone_activity';
export const TOTAL_SITE_VISITS_NAME = '# Site Visits';
export const TOTAL_SITE_VISITS_FIELD = 'total_site_visits';
export const TOTAL_USER_LOGINS_NAME = '# Logins';
export const TOTAL_USER_LOGINS_FIELD = 'total_user_logins';
export const TOTAL_SEARCHES_PERFORMED_NAME = '# Searches Performed';
export const TOTAL_SEARCHES_PERFORMED_FIELD = 'total_searches_performed';
export const TOTAL_SAVED_SEARCHES_NAME = '# Saved Searches';
export const TOTAL_SAVED_SEARCHES_FIELD = 'total_saved_searches';
export const TOTAL_PROPERTY_VIEWS_NAME = '# Property Views';
export const TOTAL_PROPERTY_VIEWS_FIELD = 'total_property_views';
export const TOTAL_FAVORITED_PROPERTIES_NAME = '# Favorited Properties';
export const TOTAL_FAVORITED_PROPERTIES_FIELD = 'total_favorited_properties';
export const TOTAL_RECEIVED_TEXTS_NAME = '# Received Texts';
export const TOTAL_RECEIVED_TEXTS_FIELD = 'total_received_texts';
export const TOTAL_SENT_TEXTS_NAME = '# Sent Texts';
export const TOTAL_SENT_TEXTS_FIELD = 'total_sent_texts';
export const TOTAL_TASKS_NAME = '# Tasks';
export const TOTAL_TASKS_FIELD = 'total_tasks';
export const UNSUBSCRIBED_DATE_NAME = 'Unsubscribed Date'
export const UNSUBSCRIBED_DATE_FIELD = 'date_unsubscribed'

export const FieldTypes = {
  Address: 'address',
  Integer: 'integer',
  Name: 'name',
  Email: 'email',
  Text: 'text',
  Hotness: 'hotness',
  Phone: 'phone',
  Tags: 'tags',
  Date: 'date',
};


const tableHeaders = [
  {
    text: 'ID',
    value: 'id',
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: 'Name',
    value: 'name',
    locked: true,
    visible: true,
    sortable: true,
    hasLink: true,
    order: 2,
    sortByColumns: ['first_name', 'last_name'],
    type: FieldTypes.Name,
  },
  {
    text: EMAIL_PRIMARY_NAME,
    value: EMAIL_PRIMARY_FIELD,
    visible: true,
    sortable: true,
    order: 3,
    type: FieldTypes.Email,
  },
  {
    text: ADDRESSES_NAME,
    value: ADDRESSES_FIELD,
    visible: false,
    sortable: true,
    order: 0,
    type: FieldTypes.Address,
  },
  {
    text: 'Home address 1',
    value: 'street_address_1',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Home'
  },
  {
    text: 'Home address 2',
    value: 'street_address_2',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Home'
  },
  {
    text: 'Home city',
    value: 'city',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Home'
  },
  {
    text: 'Home state',
    value: 'state',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Home'
  },
  {
    text: 'Home zip',
    value: 'zip',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Home'
  },
  {
    text: 'Main Office address 1',
    value: 'street_address_1',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Main Office'
  },
  {
    text: 'Main Office address 2',
    value: 'street_address_2',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Main Office'
  },
  {
    text: 'Main Office city',
    value: 'city',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Main Office'
  },
  {
    text: 'Main Office state',
    value: 'state',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Main Office'
  },
  {
    text: 'Main Office zip',
    value: 'zip',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Main Office'
  },
  {
    text: 'Branch Office address 1',
    value: 'street_address_1',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Branch Office'
  },
  {
    text: 'Branch Office address 2',
    value: 'street_address_2',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Branch Office'
  },
  {
    text: 'Branch Office city',
    value: 'city',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Branch Office'
  },
  {
    text: 'Branch Office state',
    value: 'state',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Branch Office'
  },
  {
    text: 'Branch Office zip',
    value: 'zip',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Branch Office'
  },
  {
    text: 'Second Home address 1',
    value: 'street_address_1',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Second Home'
  },
  {
    text: 'Second Home address 2',
    value: 'street_address_2',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Second Home'
  },
  {
    text: 'Second Home city',
    value: 'city',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Second Home'
  },
  {
    text: 'Second Home state',
    value: 'state',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Second Home'
  },
  {
    text: 'Second Home zip',
    value: 'zip',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Second Home'
  },
  {
    text: 'Investment address 1',
    value: 'street_address_1',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Investment'
  },
  {
    text: 'Investment address 2',
    value: 'street_address_2',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Investment'
  },
  {
    text: 'Investment city',
    value: 'city',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Investment'
  },
  {
    text: 'Investment state',
    value: 'state',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Investment'
  },
  {
    text: 'Investment zip',
    value: 'zip',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Investment'
  },
  {
    text: 'Mailing address 1',
    value: 'street_address_1',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Mailing'
  },
  {
    text: 'Mailing address 2',
    value: 'street_address_2',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Mailing'
  },
  {
    text: 'Mailing city',
    value: 'city',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Mailing'
  },
  {
    text: 'Mailing state',
    value: 'state',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Mailing'
  },
  {
    text: 'Mailing zip',
    value: 'zip',
    visible: false,
    sortable: false,
    order: 0,
    type: FieldTypes.Address,
    address_type: 'Mailing'
  },
  {
    text: 'Owner',
    value: 'owner_name',
    visible: true,
    sortable: true,
    order: 0,
    sortByColumns: ['owner_first_name', 'owner_last_name'],
    type: FieldTypes.text,
  },
  {
    text: HOTNESS_NAME,
    value: HOTNESS_FIELD,
    visible: true,
    sortable: true,
    order: 1,
    sortByColumns: ['hotness_rank'],
    type: FieldTypes.Hotness,
  },
  {
    text: PHONE_MOBILE_NAME,
    value: PHONE_MOBILE_FIELD,
    visible: true,
    sortable: true,
    order: 4,
    type: FieldTypes.Phone,
  },
  {
    text: TAGS_NAME,
    value: TAGS_FIELD,
    visible: true,
    sortable: false,
    order: 5,
    type: FieldTypes.Tags,
  },
  {
    text: 'Status',
    value: 'status',
    visible: true,
    sortable: true,
    order: 6,
    type: FieldTypes.text,
  },
  {
    value: 'owner_user_id',
    visible: false,
  },
  {
    value: 'assigned_user_id',
    visible: false,
  },
  {
    text: 'Anniversary',
    value: 'anniversary',
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: 'Assigned (First)',
    value: 'assigned_user_first_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: 'Assigned (Last)',
    value: 'assigned_user_last_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: 'Assigned',
    value: 'assigned_name',
    visible: false,
    sortable: true,
    sortByColumns: ['assigned_user_first_name', 'assigned_user_last_name'],
    type: FieldTypes.text,
  },
  {
    text: 'Birthday',
    value: 'birthday',
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: 'Company',
    value: 'company',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: null,
    value: 'contact_list_ids',
    visible: false,
  },
  {
    text: CREATED_AT_NAME,
    value: CREATED_AT_FIELD,
    visible: true,
    sortable: true,
    type: FieldTypes.Date,
    order: 9,
  },
  {
    text: LAST_EMAIL_TEXT_SENT_AT_NAME,
    value: LAST_EMAIL_TEXT_SENT_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_ACTIVITY_AT_NAME,
    value: LAST_ACTIVITY_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_COMMENT_AT_NAME,
    value: LAST_COMMENT_AT_FIELD,
    visible: true,
    sortable: true,
    type: FieldTypes.Date,
    order: 7,
  },
  {
    text: LAST_PHONE_ACTIVITY_AT_NAME,
    value: LAST_PHONE_ACTIVITY_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_SITE_VISIT_AT_NAME,
    value: LAST_SITE_VISIT_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_USER_LOGIN_AT_NAME,
    value: LAST_USER_LOGIN_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_SEARCH_PERFORMED_AT_NAME,
    value: LAST_SEARCH_PERFORMED_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_SAVED_SEARCH_ADDED_AT_NAME,
    value: LAST_SAVED_SEARCH_ADDED_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_SAVED_SEARCH_REMOVED_AT_NAME,
    value: LAST_SAVED_SEARCH_REMOVED_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_PROPERTY_VIEWED_AT_NAME,
    value: LAST_PROPERTY_VIEWED_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_FAVORITE_PROPERTY_ADDED_AT_NAME,
    value: LAST_FAVORITE_PROPERTY_ADDED_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: LAST_FAVORITE_PROPERTY_REMOVED_AT_NAME,
    value: LAST_FAVORITE_PROPERTY_REMOVED_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: CAMPAIGN_ACTION_NAME,
    value: CAMPAIGN_ACTION_FIELD,
    visible: true,
    sortable: false,
    type: FieldTypes.Date,
  },
  {
    text: null,
    value: 'next_ap_task_regular_at',
    visible: false,
    type: FieldTypes.Date,
  },
  {
    text: null,
    value: 'next_other_contact_at',
    visible: false,
    type: FieldTypes.Date,
  },
  {
    text: NEXT_TASK_AT_NAME,
    value: NEXT_TASK_AT_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: EMAIL_SECONDARY_NAME,
    value: EMAIL_SECONDARY_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Email,
  },
  {
    text: 'First Name',
    value: 'first_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: null,
    value: 'hotness_color',
    visible: false,
  },
  {
    text: null,
    value: 'hotness_id',
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: null,
    value: 'hotness_rank',
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: null,
    value: 'is_private',
    visible: false,
  },
  {
    text: 'Last Name',
    value: 'last_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: 'Owner (First)',
    value: 'owner_first_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: 'Owner (Last)',
    value: 'owner_last_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: FAX_NAME,
    value: FAX_FIELD,
    visible: false,
    type: FieldTypes.Phone,
  },
  {
    text: PHONE_HOME_NAME,
    value: PHONE_HOME_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Phone,
  },
  {
    text: PHONE_OFFICE_NAME,
    value: PHONE_OFFICE_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Phone,
  },
  {
    text: null,
    value: 'shared_users_ids',
    visible: false,
  },
  {
    text: null,
    value: 'shared_users_total',
    visible: false,
  },
  {
    text: 'Source',
    value: 'source',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: null,
    value: 'source_id',
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: 'Spouse Birthday',
    value: 'spouse_birthday',
    visible: false,
    sortable: true,
    type: FieldTypes.Date,
  },
  {
    text: SPOUSE_EMAIL_NAME,
    value: SPOUSE_EMAIL_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Email,
  },
  {
    text: SPOUSE_PHONE_NAME,
    value: SPOUSE_PHONE_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Phone,
  },
  {
    text: 'Spouse Name',
    value: 'spouse_name',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: null,
    value: 'is_active',
    visible: false,
  },
  {
    text: null,
    value: 'tag_names_id',
    visible: false,
  },
  {
    text: TOTAL_ACTIVITIES_NAME,
    value: TOTAL_ACTIVITIES_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: null,
    value: TOTAL_AP_TASKS_RECURRING_FIELD,
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_CAMPAIGNS_TASKS_NAME,
    value: TOTAL_CAMPAIGNS_TASKS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_COMMENTS_NAME,
    value: TOTAL_COMMENTS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: null,
    value: TOTAL_CONTACT_ACTIONS_FIELD,
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_EMAILS_TEXTS_NAME,
    value: TOTAL_EMAILS_TEXTS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: null,
    value: TOTAL_OTHER_CONTACTS_FIELD,
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_PHONE_ACTIVITY_NAME,
    value: TOTAL_PHONE_ACTIVITY_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_SITE_VISITS_NAME,
    value: TOTAL_SITE_VISITS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_USER_LOGINS_NAME,
    value: TOTAL_USER_LOGINS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_SEARCHES_PERFORMED_NAME,
    value: TOTAL_SEARCHES_PERFORMED_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_SAVED_SEARCHES_NAME,
    value: TOTAL_SAVED_SEARCHES_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_PROPERTY_VIEWS_NAME,
    value: TOTAL_PROPERTY_VIEWS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_FAVORITED_PROPERTIES_NAME,
    value: TOTAL_FAVORITED_PROPERTIES_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_RECEIVED_TEXTS_NAME,
    value: TOTAL_RECEIVED_TEXTS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_SENT_TEXTS_NAME,
    value: TOTAL_SENT_TEXTS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: TOTAL_TASKS_NAME,
    value: TOTAL_TASKS_FIELD,
    visible: false,
    sortable: true,
    type: FieldTypes.Integer,
  },
  {
    text: 'Type',
    value: 'type',
    visible: false,
    sortable: true,
    type: FieldTypes.text,
  },
  {
    text: null,
    value: 'type_id',
    visible: false,
    type: FieldTypes.Integer,
  },
  {
    text: 'Unsubscribed Date',
    value: 'date_unsubscribed',
    visible: false,
    type: FieldTypes.Date,
  },
];

export const specialSortColumns = getSpecialSortColumns(tableHeaders);

export default tableHeaders;
